export const SINGLE_FEEDBACK_DIALOG_ID = 'single-feedback-dialog';

export const ROLES = {
    BUYER: 'buyer',
    SELLER: 'seller'
} as const;
export const MAX_COMMENT_LENGTH = 80;
export const UNSET_RATING_VALUE = 0;
export const MIN_RATING_VALUE = 1;
export const MAX_RATING_VALUE = 5;

export enum RATING_NAMES {
    DESCRIPTION = 'ItemAsDescribed',
    COMMUNICATION = 'CommResponsiveness',
    SHIPPING_TIME = 'ShippingTime',
    SHIPPING_COST = 'ShippingHandlingCharges',
    PAYMENT_TIME = 'PaymentTime'
}

export const RATING_NAMES_SELLER = [RATING_NAMES.PAYMENT_TIME];

export const RATING_NAMES_BUYER = [
    RATING_NAMES.DESCRIPTION,
    RATING_NAMES.COMMUNICATION,
    RATING_NAMES.SHIPPING_TIME,
    RATING_NAMES.SHIPPING_COST
];

type RatingSetting = {
    name: RATING_NAMES;
    titleKey: string;
    descriptionKeys: [string, string, string, string, string];
};

export const RATING_SETTINGS: Record<RATING_NAMES, RatingSetting> = {
    [RATING_NAMES.DESCRIPTION]: {
        name: RATING_NAMES.DESCRIPTION,
        titleKey: 'leaveFeedback_rateItemAsDecribedTitle',
        descriptionKeys: [
            'leaveFeedback_rateItemAsDecribed_ratingOne',
            'leaveFeedback_rateItemAsDecribed_ratingTwo',
            'leaveFeedback_rateItemAsDecribed_ratingThree',
            'leaveFeedback_rateItemAsDecribed_ratingFour',
            'leaveFeedback_rateItemAsDecribed_ratingFive'
        ]
    },
    [RATING_NAMES.COMMUNICATION]: {
        name: RATING_NAMES.COMMUNICATION,
        titleKey: 'leaveFeedback_rateCommResponsivenessTitle',
        descriptionKeys: [
            'leaveFeedback_rateCommResponsiveness_ratingOne',
            'leaveFeedback_rateCommResponsiveness_ratingTwo',
            'leaveFeedback_rateCommResponsiveness_ratingThree',
            'leaveFeedback_rateCommResponsiveness_ratingFour',
            'leaveFeedback_rateCommResponsiveness_ratingFive'
        ]
    },
    [RATING_NAMES.SHIPPING_TIME]: {
        name: RATING_NAMES.SHIPPING_TIME,
        titleKey: 'leaveFeedback_rateShippingTimeTitle',
        descriptionKeys: [
            'leaveFeedback_rateShippingTime_ratingOne',
            'leaveFeedback_rateShippingTime_ratingTwo',
            'leaveFeedback_rateShippingTime_ratingThree',
            'leaveFeedback_rateShippingTime_ratingFour',
            'leaveFeedback_rateShippingTime_ratingFive'
        ]
    },
    [RATING_NAMES.SHIPPING_COST]: {
        name: RATING_NAMES.SHIPPING_COST,
        titleKey: 'leaveFeedback_rateShippingHandlingChargesTitle',
        descriptionKeys: [
            'leaveFeedback_rateShippingHandlingCharges_ratingOne',
            'leaveFeedback_rateShippingHandlingCharges_ratingTwo',
            'leaveFeedback_rateShippingHandlingCharges_ratingThree',
            'leaveFeedback_rateShippingHandlingCharges_ratingFour',
            'leaveFeedback_rateShippingHandlingCharges_ratingFive'
        ]
    },
    [RATING_NAMES.PAYMENT_TIME]: {
        name: RATING_NAMES.PAYMENT_TIME,
        titleKey: 'leaveFeedback_ratePaymentTimeTitle',
        descriptionKeys: [
            'leaveFeedback_ratePaymentTime_ratingOne',
            'leaveFeedback_ratePaymentTime_ratingTwo',
            'leaveFeedback_ratePaymentTime_ratingThree',
            'leaveFeedback_ratePaymentTime_ratingFour',
            'leaveFeedback_ratePaymentTime_ratingFive'
        ]
    }
};
